// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.uppercase[data-v-571764bb] {\n  text-transform: uppercase;\n}\ninput.uppercase[data-v-571764bb]::-webkit-input-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-571764bb]::-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-571764bb]:-moz-placeholder {\n  text-transform: none;\n}\ninput.uppercase[data-v-571764bb]:-ms-input-placeholder {\n  text-transform: none;\n}", ""]);
// Exports
module.exports = exports;
